import React, { useState } from "react";
import { ApiCall } from "../../Redux/Actions/ApiCall";
import { urls } from "../../Utils/url";
import { loginPage } from "../../Redux/Actions/Authentication";
import { connect } from "react-redux";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import { toast } from "react-toastify";
import { useMediaQuery } from "react-responsive";
const CompanyImage = companyId => {
  switch (companyId) {
    case 1:
      return require("../../assets/images/Water.png");
    case 2:
      return require("../../assets/images/Gas.png");
    case 3:
      return require("../../assets/images/Electricity.png");
    case 4:
      return require("../../assets/images/MCI.png");
    case 5:
      return require("../../assets/images/Telephone.png");
    default:
      break;
  }
};

export const inquireBill = (
  billId,
  companyId,
  setPayment,
  setAmount,
  token,
  setDate,
  setInfo,
  setLoading,
  setBillName,
  period,
  setBillParam,
  history
) => {
  const URL =
    !period && (companyId === 4 || companyId === 5)
      ? `${urls.Inquire}?bill_company_id=${companyId}&parameter=${billId}&type=now`
      : `${urls.Inquire}?bill_company_id=${companyId}&parameter=${billId}`;
  setLoading(true);
  ApiCall(
    "get",
    URL,
    null,
    "BillInquire",
    token,
    function(e) {
      setLoading(false);
      const data = e.data;

      if (
        data &&
        (data.payment_status === 0 ||
          data.payment_status === null ||
          data.payment_status === undefined)
      ) {
        setAmount(data.amount);
        setBillParam(data.id);
        if (data.info !== {}) {
          setBillName(data.info.CustomerName || data.info.OwnerName);
        }
        if (companyId === 4) {
          setBillName("همراه اول");
        }
        if (companyId === 5) {
          setBillName("تلفن ثابت");
        }
        setInfo(data.info);
        setDate(data.date);
        setPayment(true);
      } else if (!data || (data && data.payment_status === 1)) {
        toast.warn(
          "قبض مورد نظر پرداخت شده است. از طریق صفحه سوابق پرداخت می توانید اطلاعات قبض را بررسی کنید",
          {
            position: "bottom-center",
            autoClose: 4500,
            hideProgressBar: true,
            pauseOnHover: false
          }
        );
      } else {
        toast.warn("قبض مورد نظر پرداخت شده است.", {
          position: "bottom-center",
          autoClose: 4500,
          hideProgressBar: true,
          pauseOnHover: false
        });
      }
    },
    function(e) {
      setLoading(false);
    }
  );
};

const PeriodBtns = ({ setPeriod }) => {
  const [selected, setSelected] = useState(1);
  return (
    <div className="PeriodBtns">
      <div
        className={selected === 0 ? "selectedPeriod" : null}
        onClick={() => {
          setSelected(0);
          setPeriod(false);
        }}
      >
        میان دوره
      </div>
      <div
        className={selected === 1 ? "selectedPeriod" : null}
        onClick={() => {
          setSelected(1);
          setPeriod(true);
        }}
      >
        پایان دوره
      </div>
    </div>
  );
};

const BillInquire = ({
  value,
  setBillId,
  setPayment,
  setBillName,
  companyId,
  setAmount,
  isLogin,
  loginOpen,
  token,
  setDate,
  setInfo,
  loading,
  setLoading,
  header,
  setBillParam,
  history
}) => {
  const [period, setPeriod] = useState(true);
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });
  const BiiIdText =
    companyId === 4
      ? "شماره تلفن همراه را وارد و یا انتخاب نمایید"
      : companyId === 5
      ? "شماره تلفن ثابت را وارد و یا انتخاب نمایید"
      : companyId === 2
      ? "شماره اشتراک را وارد و یا انتخاب نمایید"
      : "شناسه قبض را وارد و یا انتخاب نمایید";

  const placeholder =
    companyId === 4
      ? "شماره تلفن همراه"
      : companyId === 5
      ? "شماره تلفن ثابت به همراه کد شهر"
      : companyId === 2
      ? "شماره اشتراک"
      : "شناسه قبض";
  return (
    <div className="BillInquire">
      {/* <div className="BillHeader"> */}
      <img src={CompanyImage(companyId)} alt="" id="companyImage" />
      <h1>{`${header}`}</h1>
      {/* </div> */}
      <h2>{BiiIdText}</h2>
      <input
        className="textInput"
        type="tel"
        autoComplete={"off"}
        id="phone"
        value={value}
        placeholder={placeholder}
        onChange={v => setBillId(v.target.value)}
      />
      {(companyId === 4 || companyId === 5) && (
        <PeriodBtns setPeriod={setPeriod} />
      )}
      {!loading ? (
        !(isTabletOrMobile && isPortrait) ? (
          <input
            type="submit"
            className="LoginButton"
            value="استعلام"
            onClick={() => {
              if (value.length === 0 && isLogin) {
                toast.warn("شناسه قبض را وارد کنید", {
                  position: "bottom-center",
                  autoClose: 4500,
                  hideProgressBar: true,
                  pauseOnHover: false
                });
              } else {
                isLogin
                  ? inquireBill(
                      value,
                      companyId,
                      setPayment,
                      setAmount,
                      token,
                      setDate,
                      setInfo,
                      setLoading,
                      setBillName,
                      period,
                      setBillParam,
                      history
                    )
                  : loginOpen();
              }
            }}
          />
        ) : (
          <input
            type="submit"
            className="PayButton"
            style={{ backgroundColor: "#2c3e50" }}
            value="استعلام"
            onClick={() => {
              if (value.length === 0 && isLogin) {
                toast.warn("شناسه قبض را وارد کنید", {
                  position: "bottom-center",
                  autoClose: 4500,
                  hideProgressBar: true,
                  pauseOnHover: false
                });
              } else {
                isLogin
                  ? inquireBill(
                      value,
                      companyId,
                      setPayment,
                      setAmount,
                      token,
                      setDate,
                      setInfo,
                      setLoading,
                      setBillName,
                      period,
                      setBillParam,
                      history
                    )
                  : loginOpen();
              }
            }}
          />
        )
      ) : !(isTabletOrMobile && isPortrait) ? (
        <div className="LoginButton" style={{ paddingTop: 13.5 }}>
          <Loader type="ThreeDots" color="white" height={5} width={20} />
        </div>
      ) : (
        <div className="PayButton" style={{ backgroundColor: "#2c3e50" }}>
          <Loader type="ThreeDots" color="white" height={5} width={20} />
        </div>
      )}
    </div>
  );
};
const mapDispatchToProps = dispatch => ({
  loginOpen: () => dispatch(loginPage(true))
});
const mapStateToProps = state => ({
  token: state.auth.token
});
export default connect(mapStateToProps, mapDispatchToProps)(BillInquire);
